import ExhibitionSection from '../../components/ExhibitionSection/ExhibitionSection';

export default function City({ lang }) {
    return (
            <ExhibitionSection
                titleEn="Exhibition Area 4: City Of Illusions"
                titleZh="展区四：幻象浮城"
                campus="guangzhou"
                area={4}
                lang={lang}
            />
    );
}
